// Dynamic report counter that simulates realistic usage throughout the day
export const getDynamicReportCount = () => {
  const now = new Date();
  const utcHour = now.getUTCHours();
  const utcMinute = now.getUTCMinutes();
  
  // Convert time to decimal hour (0-24)
  const decimalHour = utcHour + (utcMinute / 60);
  
  // Create a realistic distribution throughout the day
  // Peak usage around 14:00-18:00 UTC (business hours in many timezones)
  let baseCount;
  
  if (decimalHour >= 0 && decimalHour < 6) {
    // Early morning UTC: 1-15 reports
    baseCount = Math.floor(1 + (decimalHour / 6) * 14);
  } else if (decimalHour >= 6 && decimalHour < 12) {
    // Morning UTC: 15-35 reports
    baseCount = Math.floor(15 + ((decimalHour - 6) / 6) * 20);
  } else if (decimalHour >= 12 && decimalHour < 18) {
    // Peak hours UTC: 35-70 reports
    baseCount = Math.floor(35 + ((decimalHour - 12) / 6) * 35);
  } else {
    // Evening UTC: 70-80 reports
    baseCount = Math.floor(70 + ((decimalHour - 18) / 6) * 10);
  }
  
  // Add some randomness to make it feel more realistic
  const randomVariation = Math.floor(Math.random() * 6) - 3; // -3 to +3
  const finalCount = Math.max(1, Math.min(80, baseCount + randomVariation));
  
  return finalCount;
};

// Get a consistent count that updates every 5 minutes to avoid constant changes
export const getStableReportCount = () => {
  const now = new Date();
  const fiveMinuteInterval = Math.floor(now.getTime() / (5 * 60 * 1000));
  
  // Use the interval as a seed for consistent randomness within 5-minute windows
  const seed = fiveMinuteInterval % 1000;
  const baseCount = getDynamicReportCount();
  
  // Add some variation based on the 5-minute interval
  const variation = (seed % 7) - 3; // -3 to +3
  
  return Math.max(1, Math.min(80, baseCount + variation));
};